import React, { useEffect, useState } from 'react';
import { BehavioralChartSC } from './behavioral-chart.styled';

import { IBehavioralTimelineData, TBehavioralModalType } from 'types/behavioral-data';
import StepsChart from './steps-chart';

interface BehavioralChartProps {
  type: TBehavioralModalType;
  selectedPeriod: string;
  onPeriodChange: (value: string) => void;
  historyDate: string | string[];
  historyCount: number;
  onHistoryStepChange: (historyType: string) => void;
  isCustomTimeSelected: boolean;
  data: IBehavioralTimelineData | null;
}

const BehavioralChart: React.FC<BehavioralChartProps> = ({
  type,
  selectedPeriod,
  onPeriodChange,
  historyDate,
  historyCount,
  onHistoryStepChange,
  isCustomTimeSelected,
  data,
}) => {
  return (
    <BehavioralChartSC>
      {type === 'STEPS' && (
        <StepsChart
          type={type}
          selectedPeriod={selectedPeriod}
          onPeriodChange={(value) => onPeriodChange(value)}
          historyDate={historyDate}
          historyCount={historyCount}
          onHistoryStepChange={(historyType: string) => onHistoryStepChange(historyType)}
          isCustomTimeSelected={isCustomTimeSelected}
          data={data}
        />
      )}
    </BehavioralChartSC>
  );
};

export default BehavioralChart;
